// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"518":"cacf71ec","675":"2f8a4d0e","745":"74e47f12","947":"26b7ee95"}[chunkId] + ".chunk.js";
};